import React from 'react';
import EntityIcon, { ExternalEntityIconProps } from './EntityIcon';
import { faUser } from '@fortawesome/pro-light-svg-icons';
import { getProjectHeaderImageThumbnailUrl } from '@/services/projects';

export type ProjectIconProps = ExternalEntityIconProps & {
    projectId: number;
};

const ProjectIcon = React.forwardRef<HTMLDivElement, ProjectIconProps>(
    ({ projectId, emptyIcon = faUser as any, shape = 'circle', fit = 'cover', ...rest }, ref) => {
        return (
            <EntityIcon
                ref={ref}
                url={getProjectHeaderImageThumbnailUrl(projectId)}
                emptyIcon={emptyIcon}
                shape={shape}
                fit={fit}
                {...rest}
            />
        );
    }
);

export default ProjectIcon;
